import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';

declare global {
  interface Window { __ZXS_WEB_VITALS__?: Record<string, Pick<Metric, 'name' | 'value' | 'rating' | 'delta'>> }
}

export function collectWebVitals() {
  const record = (metric: Metric) => {
    window.__ZXS_WEB_VITALS__ ??= {};
    window.__ZXS_WEB_VITALS__[metric.name] = { name: metric.name, value: metric.value, rating: metric.rating, delta: metric.delta };
  };
  onLCP(record, { reportAllChanges: true });
  onINP(record, { reportAllChanges: true });
  onCLS(record, { reportAllChanges: true });
}
